import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { GraduationCap, PlayCircle, CheckCircle2 } from "lucide-react";
import { Card, Empty } from "../panel/PanelShell";
import { api } from "../../lib/api";
import { useLearning, courseStats, LEVEL_STYLES } from "../../lib/learning";
import { fmtDate } from "../../lib/format";

export default function LearningTab() {
  const [courses, setCourses] = useState(null);
  const { progress, loaded } = useLearning();
  useEffect(() => { api.get("/courses").then((r) => setCourses(r.data)); }, []);
  if (!courses || !loaded) return null;
  if (!courses.length) return <Empty text="No courses available yet." testid="learning-empty" />;
  const started = courses.filter((c) => progress[c.slug]);
  const completedCount = started.filter((c) => courseStats(c, progress[c.slug]).completed).length;

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap items-center gap-6 rounded-2xl bg-navy p-6 text-white" data-testid="learning-summary">
        <GraduationCap className="text-gold" size={28} />
        <div className="flex-1"><p className="font-semibold">Your learning journey</p><p className="text-sm text-slate-400">{started.length} started · {completedCount} completed · {courses.length} available</p></div>
        <Link to="/learn" data-testid="learning-browse-btn" className="rounded-full bg-mint px-5 py-2.5 text-sm font-semibold text-navy">Browse courses</Link>
      </div>
      <div className="grid gap-4 lg:grid-cols-2">
        {courses.map((c) => {
          const p = progress[c.slug];
          const s = courseStats(c, p);
          return (
            <Card key={c.slug} data-testid={`learning-course-${c.slug}`}>
              <div className="flex items-start justify-between gap-3">
                <div>
                  <span className={`rounded-full px-2.5 py-0.5 text-[11px] font-bold ${LEVEL_STYLES[c.level]}`}>{c.level}</span>
                  <h3 className="mt-2 font-bold text-navy">{c.title}</h3>
                  <p className="text-xs text-slate-500">{c.lesson_count} lessons · {c.total_minutes} min{p?.updated_at ? ` · last activity ${fmtDate(p.updated_at)}` : ""}</p>
                </div>
                {s.completed && <CheckCircle2 className="text-mint" />}
              </div>
              <div className="mt-5 h-2 overflow-hidden rounded-full bg-slate-100"><div className="h-full rounded-full bg-mint" style={{ width: `${s.pct}%` }} /></div>
              <div className="mt-3 flex items-center justify-between">
                <span className="font-num text-sm text-navy" data-testid={`learning-progress-${c.slug}`}>{s.done.length}/{s.total} lessons{s.hasQuiz ? ` · quiz ${s.quizPassed ? "passed" : "pending"}` : ""} · {s.pct}%</span>
                <Link to={s.nextPath} data-testid={`learning-continue-${c.slug}`} className="inline-flex items-center gap-1.5 text-sm font-semibold text-mint-600">
                  <PlayCircle size={15} /> {s.completed ? "Review" : s.quizPending ? "Take quiz" : s.started ? "Continue" : "Start"}
                </Link>
              </div>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
